module.exports = __webpack_public_path__ + "img/sb02-06.d567f566.png";